import styled from "styled-components";
import { FC } from "react";
import { PillComponent } from "components/resources/resourceHub/PillComponent";
import { color } from "@styles";
import Image from "next/image";
import Link from "next/link";
import { Truncator } from "components/atoms/Truncator";

export interface AdviserResourceCardProps {
  title: string;
  description: string;
  imgSrc: string;
  imgAlt?: string;
  resourceType?: "DOC" | "Presentation" | "PDF";
  slug?: string;
  linkText?: string;
}

export const AdviserResourceCard: FC<AdviserResourceCardProps> = ({
  title,
  description,
  imgSrc,
  imgAlt,
  resourceType,
  slug,
  linkText,
}) => {
  const advisorPage = resourceType ? true : false;

  return (
    <Card>
      <Link href={slug} target="_blank">
        <ResourceImage
          src={imgSrc}
          alt={imgAlt}
          width={360}
          height={199}
          $advisorPage={advisorPage}
        />
      </Link>
      {resourceType && <PillComponent tag={resourceType} />}
      <Link href={slug} target="_blank">
        <Title $advisorPage={advisorPage}>
          <Truncator $lines={2}>{title}</Truncator>
        </Title>
        <Description>
          <Truncator $lines={3}>{description}</Truncator>
        </Description>
        <Download>{linkText ? linkText : "Download now"}</Download>
      </Link>
    </Card>
  );
};

const Card = styled.div`
  max-width: 22.5rem;
  flex: 1;
`;

const ResourceImage = styled(Image)<{
  $advisorPage: boolean;
}>`
  width: 100%;
  min-width: 16.875rem;
  object-fit: cover;
  border-radius: 0.5rem;
  margin-bottom: ${(p) => (p.$advisorPage ? "1.25rem" : "1.5rem")};
`;

const Title = styled.p<{
  $advisorPage: boolean;
}>`
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 0.06rem;
  margin-top: ${(p) => (p.$advisorPage ? "1.5rem" : "0")};
`;
const Description = styled.p`
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: 0.06rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

const Download = styled.p`
  text-decoration: underline;
  color: ${color.P100};
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 2rem;
  letter-spacing: 0.075rem;
`;
